const o = "_collection_awvdb_19", c = "_labels_awvdb_22", i = "_icon_awvdb_39", _ = "_floating_awvdb_71", a = "_isDisabled_awvdb_88", n = {
  "compare-bar-chip-root": "_compare-bar-chip-root_awvdb_1",
  collection: o,
  labels: c,
  "color-indicator": "_color-indicator_awvdb_35",
  icon: i,
  "action-icon": "_action-icon_awvdb_45",
  "is-collection": "_is-collection_awvdb_58",
  "is-selected": "_is-selected_awvdb_63",
  "no-action-icon": "_no-action-icon_awvdb_67",
  floating: _,
  "no-color-indicator": "_no-color-indicator_awvdb_75",
  "search-filter": "_search-filter_awvdb_79",
  isDisabled: a
};
export {
  o as collection,
  n as default,
  _ as floating,
  i as icon,
  a as isDisabled,
  c as labels
};
//# sourceMappingURL=index.es705.js.map
